import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, watch, computed } from "vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import SearchPageSearchPagination from "@/components/v2/search-page/SearchPageSearchPagination.vue";
import SearchPageSearchResultsButtons from "@/components/v2/search-page/SearchPageSearchResultsButtons.vue";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";
import SearchPageSearchResultsTable from "@/components/v2/search-page/SearchPageSearchResultsTable.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageSearchResultsHeader',
  props: {
    sticky: { type: Boolean, default: false }
  },
  setup(__props: any) {

const searchPageStore = useSearchPageStore();

const props = __props;

const isLoading = computed<boolean>(
  () => searchPageStore.searchPageState.loading
);

const error = computed<boolean>(
  () => searchPageStore.searchPageState.searchResults.error
);

const searchResults = ref<
  CertificationSearchResultModel[] | DisbursementSearchResultModel[]
>([]);

watch(
  () => searchPageStore.searchPageState.searchResults.data,
  (newValue) => {
    searchResults.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    name: "xpage-search-results-title",
    class: _normalizeClass(["search-page-search-results-title", { 'sticky-wrapper': __props.sticky }])
  }, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
      : (!isLoading.value && error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(searchPageStore).searchPageState.searchResults.errorMessage), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(SearchPageSearchPagination),
            _createVNode(SearchPageSearchResultsButtons),
            _withDirectives(_createVNode(SearchPageSearchResultsTable, {
              results: searchResults.value,
              showHeaders: true,
              showRows: false,
              freezeHeaderRow: _unref(searchPageStore).searchPageState.layout === 'table'
            }, null, 8, ["results", "freezeHeaderRow"]), [
              [_vShow, 
          searchResults.value &&
          searchResults.value.length > 0 &&
          !isLoading.value &&
          _unref(searchPageStore).searchPageState.layout !== 'boxes'
        ]
            ])
          ]))
  ], 2))
}
}

})